var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        id: "ConfirmModal",
        footer: null,
        closable: false,
        header: null,
        visible: true,
        width: "600px",
      },
    },
    [
      _c(
        "div",
        { staticClass: "delete-modal-cancel", on: { click: _vm.handleCancel } },
        [
          _c(
            "span",
            {
              staticClass: "md-icon",
              staticStyle: { color: "#ec4b1d", cursor: "pointer" },
            },
            [_vm._v("cancel")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "delete-modal-image" },
        [
          _c("ConfirmModalIcon", {
            staticStyle: { width: "300px", "max-height": "150px" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "delete-modal-text" }, [
        _vm._v(_vm._s(_vm.description)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "task-status-form" },
        [
          _c("div", { staticClass: "status-buttons" }, [
            _c(
              "button",
              {
                staticClass: "status-button",
                class: { active: _vm.status === "Won" },
                on: {
                  click: function ($event) {
                    return _vm.selectStatus("Won")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("emoji_events"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("task.confirmModalStatusWon"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "status-button",
                class: { active: _vm.status === "Lost" },
                on: {
                  click: function ($event) {
                    return _vm.selectStatus("Lost")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("cancel"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("task.confirmModalStatusLost"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "status-button",
                class: { active: _vm.status === "Paused" },
                on: {
                  click: function ($event) {
                    return _vm.selectStatus("Paused")
                  },
                },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("pause_circle"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("task.confirmModalStatusPaused"))),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.status
              ? _c(
                  "div",
                  { staticClass: "description-area" },
                  [
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("task.confirmModalDescriptionLabel"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("a-textarea", {
                      attrs: {
                        rows: 3,
                        placeholder: _vm.$t(
                          "task.confirmModalDescriptionPlaceholder"
                        ),
                      },
                      model: {
                        value: _vm.statusDescription,
                        callback: function ($$v) {
                          _vm.statusDescription = $$v
                        },
                        expression: "statusDescription",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "delete-modal-slot" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.modalBtnVisible
        ? _c("div", { staticClass: "modal-actions" }, [
            _c(
              "button",
              { staticClass: "cancel-button", on: { click: _vm.handleCancel } },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.btnCancelText) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "confirm-button",
                attrs: { disabled: !_vm.status },
                on: { click: _vm.handleConfirm },
              },
              [_vm._v("\n            " + _vm._s(_vm.btnoktext) + "\n        ")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }